import { render, staticRenderFns } from "./ProductOrderDetails.vue?vue&type=template&id=1db48240"
import script from "./ProductOrderDetails.vue?vue&type=script&lang=js"
export * from "./ProductOrderDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports